import { render, staticRenderFns } from "./SellRequests.vue?vue&type=template&id=74b35fbb&"
import script from "./SellRequests.vue?vue&type=script&lang=js&"
export * from "./SellRequests.vue?vue&type=script&lang=js&"
import style0 from "./SellRequests.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports